import { NavIcon } from './NavIcon';

import type { ReactNode } from 'react';

export type NavConfigEntry = {
    title: string;
    path: string;
    icon: ReactNode;
    available: boolean;
};

const navConfig: NavConfigEntry[] = [
    {
        title: 'Dashboard',
        path: '/dashboard',
        icon: <NavIcon name="dashboard"/>,
        available: true
    },
    {
        title: 'Roadmaps',
        path: '/roadmaps',
        icon: <NavIcon name="roadmaps"/>,
        available: true
    },
    {
        title: 'Courses',
        path: '/courses',
        icon: <NavIcon name="courses"/>,
        available: true
    },
    {
        title: 'Workouts',
        path: '/workouts',
        icon: <NavIcon name="workouts"/>,
        available: true
    },
    {
        title: 'Inside [Preview]',
        path: '/inside',
        icon: <NavIcon name="inside"/>,
        available: true
    },
    {
        title: 'Profile',
        path: '/profile',
        icon: <NavIcon name="profile"/>,
        available: true
    }
].filter((item) => item.available);

export default navConfig;
